import React, { Component } from 'react';
import styles from './ShipmentTrackingModule.module.css';

class ShipmentMethod extends Component {
    constructor(props) {
        super(props)

        this.state = {
            methods: []
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            methods: nextProps.methodDetails.shipment_tracking_method
        }
    }

    render() {
        const { methods } = this.state
        return (
            <div>
                <h3 className="data_header">Shipment and Tracking Methods</h3>
                <div className='overflow-auto'>
                <table className={`table table-bordered ${styles.methodsTable}`}>
                    <thead>
                        <tr>
                            <th className={styles.table1}>Sr. No.</th>
                            <th className={styles.table2}>Methods used</th>
                            <th className={styles.table3}>Details of methods used</th>
                            <th className={styles.table4}>GPS Service Provider(s) used to track shipment/trucks</th>
                        </tr>
                    </thead>
                    {
                        (methods === null || methods === undefined || methods.length === 0) ? (
                            <tbody>
                                <tr>
                                    <td colSpan="4">
                                        Details not available
                                    </td>
                                </tr>
                            </tbody>
                        ) : (<tbody>

                            {methods.map((method, index) =>
                                <tr key={index}>
                                    <td className={styles.table1}> {index + 1} </td>
                                    <td className={styles.table2}>  {method.methods_used} </td>
                                    <td className={styles.table3}>  {method.details_of_method} </td>
                                    <td className={styles.table4}>  {method.service_provider} </td>
                                </tr>
                            )}
                        </tbody>

                        )
                    }
                </table>
                </div>
            </div>
        )
    }
}

export default ShipmentMethod
